import React, { useState } from 'react';

// Utils
import { balanceFormatter } from '~/utils/helperFunctions';
import { INVOICE_HEADERS, PRODUCT_PRICING_HEADERS } from '~/utils/constants';
import { dateFormat } from '~/utils/date-format';
import { MESSAGES } from '~/utils/message';

// Components
import Loader from '~/components/General/Loader';

// MUI Components
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, PaginationItem, Typography } from '@mui/material';

// Icon
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// Styles
import './styles.scss';

const index = (props) => {
  const { tableType, data, callback, loading = false } = props;

  const [prevCount, setPrevCount] = useState(0);

  return (
    <>
      <TableContainer component={Paper} className="plansTableWrapper">
        <Table aria-label="simple table">
          <TableHead>
            {tableType === 'product' ? (
              <TableRow>
                {PRODUCT_PRICING_HEADERS.map((header, index) => (
                  <TableCell align="left" key={index}>
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            ) : (
              <TableRow>
                {INVOICE_HEADERS.map((header, index) => (
                  <TableCell align="left" key={index}>
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {tableType === 'product'
              ? data.map((row, index) => (
                  <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="left">{balanceFormatter(row.starter, 3)}</TableCell>
                    <TableCell align="left">{balanceFormatter(row.growth, 3)}</TableCell>
                    <TableCell align="left">{balanceFormatter(row.professional, 3)}</TableCell>
                    <TableCell align="left">{row.enterprise}</TableCell>
                  </TableRow>
                ))
              : !loading &&
                data.rows.map((row, index) => (
                  <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell component="th" scope="row">
                      {dateFormat(row.date, true)}
                    </TableCell>
                    <TableCell align="left">{row.description}</TableCell>
                    <TableCell align="left">{balanceFormatter(row.total)}</TableCell>
                    <TableCell align="left">
                      <Box className="invoiceStatus">
                        {row.status}
                        <ArrowForwardIosIcon
                          role="button"
                          tabIndex={0}
                          aria-label={`Open invoice from ${dateFormat(row.date, true)}`}
                          onClick={() => window.open(row.hosted_invoice_url, '_blank')}
                          onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                              event.preventDefault();
                              window.open(row.hosted_invoice_url, '_blank');
                            }
                          }}
                        />
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}

            {tableType === 'invoice' && !data.rows.length && !loading && (
              <TableRow className="planInvoiceEmptyRow">
                <TableCell colSpan={INVOICE_HEADERS.length}>
                  <Typography className="planInvoiceEmptyText">
                    {MESSAGES.ACCOUNT.PLANS.INVOICE.NO_RESULT_TEXT}
                  </Typography>
                </TableCell>
              </TableRow>
            )}

            {tableType === 'invoice' && loading && (
              <TableRow className="planInvoiceLoadingRow">
                <TableCell colSpan={INVOICE_HEADERS.length}>
                  <Loader />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {tableType === 'invoice' && (
        <Box
          component="nav"
          aria-label="Invoice pagination"
          className="MuiPagination-root planCursorPagination"
        >
          <Box component="ul" className="MuiPagination-ul">
            <Box component="li">
              <PaginationItem
                aria-label="Previous invoices"
                type="previous"
                variant="outlined"
                shape="rounded"
                disabled={prevCount <= 0}
                slots={{ previous: ArrowBackIosNewIcon }}
                onClick={() => {
                  callback({ endingBefore: data.endingBefore });
                  setPrevCount((count) => count - 1);
                }}
              />
            </Box>
            <Box component="li">
              <PaginationItem
                aria-label="Next invoices"
                type="next"
                variant="outlined"
                shape="rounded"
                disabled={(!data.has_more && prevCount !== 0) || !data.rows.length}
                slots={{ next: ArrowForwardIosIcon }}
                onClick={() => {
                  callback({ startingAfter: data.startingAfter });
                  setPrevCount((count) => count + 1);
                }}
              />
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default index;
